import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-image-dialog',
  templateUrl: './image-dialog.component.html',
})
export class ImageDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: { images: any[], currentIndex: number }) {}

  previous(): void {
    this.data.currentIndex = (this.data.currentIndex > 0) ? this.data.currentIndex - 1 : this.data.images.length - 1;
  }

  next(): void {
    this.data.currentIndex = (this.data.currentIndex + 1) % this.data.images.length;
  }
}
